/* eslint-disable require-jsdoc */
import {Brick, registerBrick} from 'olympe';
import ReactDOM from 'react-dom';
import React from 'react';
import {EndOfSubmitPRContent} from './end_of_submit_pr/EndOfSubmitPRContent.jsx';
import {merge} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApprovalNeededPopupNewSubmit} from '../pr_editor/dialogs/ApprovalNeededPopupNewSubmit.jsx';

export default class EndOfSubmitPRBrick extends Brick {
    /**
     * @override
     * @param {BrickContext} $
     */
    setupExecution($) {
        const [ctrlInput,
            pr,
            tag,
            sbNeeded,
            sapPRNumber,
            reasonsForApproval,
            sbApprovers,
            errorDescriptor,
            errorFlowInput,
            getUserIdGraphAPI,
            sendEmail,
            savePR] = this.getInputs();
        return merge($.observe(ctrlInput), $.observe(errorFlowInput)).pipe(map((input) => {
            return [$.get(ctrlInput),
                $.get(pr),
                $.get(tag),
                $.get(sbNeeded),
                $.get(sapPRNumber),
                $.get(reasonsForApproval),
                $.get(sbApprovers),
                $.get(errorDescriptor),
                $.get(errorFlowInput),
                $.get(getUserIdGraphAPI),
                $.get(sendEmail),
                $.get(savePR)];
        }));
    }
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {number} inputCtrlFlow
     * @param {boolean} sbNeeded
     * @param {boolean} obNeeded
     * @param {string} sapPRNumber
     * @param {string[]} reasonsForApproval
     * @param {string[]} sBApprovers
     * @param {*} errorDescriptor
     * @param {*} errorFlow
     * @param {function()} forwardEvent
     * @param {function(string)} setSapPRNumber
     * @param {function(*)} setErrorFlow
     */
    update($, [inputCtrlFlow,
        pr,
        tag,
        sbNeeded,
        sapPRNumber,
        reasonsForApproval,
        sbApprovers,
        errorDescriptor,
        errorFlow,
        getUserIdGraphAPI,
        sendEmail,
        savePR], [forwardEvent, setSapPRNumber, setErrorFlow]) {
        const popupId = 'popup018c4456980a363b6704';
        if (!document.getElementById(popupId)) {
            const head = document.body;
            const popup = document.createElement('div');
            popup.id = popupId;
            head.appendChild(popup);
        }

        if (sbNeeded) {
            ReactDOM.render((<ApprovalNeededPopupNewSubmit
                $={$}
                inputCtrlFlow={inputCtrlFlow}
                pr={pr}
                tag={tag}
                forwardEvent={forwardEvent}
                setErrorFlow={setErrorFlow}
                getUserIdGraphAPI={getUserIdGraphAPI}
                sendEmail={sendEmail}
                savePR={savePR}
                open
                sbApprovers={sbApprovers}
                reasonsForApproval={reasonsForApproval}
            />), document.getElementById(popupId));
        } else {
            ReactDOM.render((<EndOfSubmitPRBrick.Component
                inputCtrlFlow={inputCtrlFlow}
                forwardEvent={forwardEvent}
                setSapPRNumber={setSapPRNumber}
                setErrorFlow={setErrorFlow}
                sapPRNumber={sapPRNumber}
                errorDescriptor={errorDescriptor}
                errorFlow={errorFlow}
            />), document.getElementById(popupId));
        }
    }
}

EndOfSubmitPRBrick.Component = (props) => {
    return (
        <EndOfSubmitPRContent {...props}/>
    );
};

registerBrick('018c4456980a363b6704', EndOfSubmitPRBrick);
